package org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.grid_customer_card_bar.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontLineHeight
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.LetterSpacing

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.LineStyle

@Composable
fun GridCustomerCardHeader(
    numberDescending:Boolean?,
    onNumberSortClick:()->Unit,
)
{
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(Dimen.gridHeaderHeight)
            .borderBottom(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
            .backgroundColor(Theme.ActionHover.rgb)
            .padding(
                leftRight = Dimen.normalPadding,
                topBottom = Dimen.smallPadding,
            ),
        verticalAlignment = Alignment.CenterVertically
    )
    {
        HeaderItem(
            title =Strings.current().numberDot,
            numberDescending =numberDescending,
            width =Dimen.gridCustomerCardNumberWidth,
            onHeaderItemClick = {}

        )


        HeaderItem(
            title = Strings.current().cardName,
            numberDescending =numberDescending,
            width = Dimen.headerLargeWidth,
            onHeaderItemClick = {}
        )

        HeaderItem(
            title =Strings.current().balance,
            numberDescending =numberDescending,
            width = Dimen.headerSmallWidth,
            arrangement = Arrangement.End,
            onHeaderItemClick = {

            }
        )

        Spacer()

        HeaderItem(
            title =Strings.current().points,
            numberDescending =numberDescending,
            width = Dimen.gridCustomerCardNumberWidth,
            arrangement = Arrangement.End,
            onHeaderItemClick = {

            }
        )


    }



}

@Composable
private fun HeaderItem(
    title: String,
    arrangement: Arrangement.Horizontal =Arrangement.Start,
    numberDescending: Boolean?,
    width: CSSSizeValue<CSSUnit.px>,
    onHeaderItemClick: () -> Unit,
) {
    Row(
        modifier = Modifier
            .width(width)
            .onClick {
                onHeaderItemClick()
            },
        horizontalArrangement =arrangement,
        verticalAlignment = Alignment.CenterVertically
    )
    {
        SpanText(
            text = title,
            modifier = Modifier
                .cursor(Cursor.Pointer)
                .fontSize(FontSizes.mediumFontSize)
                .fontWeight(FontWeight.Medium)
                .lineHeight(FontLineHeight.lineMedium)
                .letterSpacing(LetterSpacing.semiMedium)
                .fontFamily(FontFamily.Jakarta)
                .color(Theme.TextPrimary.rgb)
        )

        VectorIcon(
            modifier = Modifier.padding(Dimen.smallPadding),
            pathData = if (numberDescending == true)
                Res.PathIcon.sortDesc
            else Res.PathIcon.sortAsc,
            height = Dimen.mediumIconSize,
            width = Dimen.mediumIconSize,
            color = Theme.TextSecondary.hex,
            visibilityStatus = numberDescending != null
        )

    }


}